import React from "react";
import { Box, Stack, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

/**
 * CommunityJoinCard - 디스코드 커뮤니티 참여 유도 카드
 * 
 * Props:
 * @param {boolean} [isMobile] - 반응형 여부 [Optional]
 * @param {Function} [onJoinClick] - 참여 버튼 클릭 콜백 [Optional]
 * @param {string} [discordInviteUrl] - 디스코드 초대 URL [Optional, 기본값: https://discord.com/invite/JWjRJ9RYk4]
 *
 * Example usage:
 * <CommunityJoinCard isMobile={isMobile} />
 */
const CommunityJoinCard = ({ isMobile, onJoinClick, discordInviteUrl = "https://discord.com/invite/JWjRJ9RYk4" }) => {
	const theme = useTheme();
	const { t } = useTranslation();

	const handleJoinClick = () => {
		if (onJoinClick) {
			onJoinClick();
		} else if (typeof window !== "undefined") {
			window.open(discordInviteUrl, "_blank", "noopener,noreferrer");
		}
	};

	return (
		<Stack 
			spacing={isMobile ? 2 : 3}
			sx={{ 
				width: "100%",
				py: isMobile ? 3 : 5,
				px: isMobile ? 2 : "32px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				textAlign: "left",
				minHeight: "200px",
				backgroundColor: "transparent",
			}}
		>
			<Box sx={{ minWidth: 0, width: "100%" }}>
				<Typography
					variant={isMobile ? "body2" : "h5"}
					sx={{
						fontFamily: '"SUIT Variable", sans-serif',
						fontWeight: 900,
						color: theme.palette.text.primary,
						lineHeight: 1.4,
						height: isMobile ? "auto" : "72px",
						overflow: "hidden",
						wordBreak: "keep-all",
						display: "-webkit-box",
						WebkitLineClamp: isMobile ? 2 : 3,
						WebkitBoxOrient: "vertical",
						fontSize: isMobile ? "0.9rem" : undefined,
						mb: isMobile ? 2 : 3,
					}}
				>
					{t("discordBanner.title")}
				</Typography>
				<Box sx={{
					display: "-webkit-box",
					WebkitLineClamp: isMobile ? 2 : 3,
					WebkitBoxOrient: "vertical",
					overflow: "hidden",
					height: isMobile ? "auto" : "88px",
					maxHeight: isMobile ? "4em" : "88px",
				}}>
					<Typography
						variant={isMobile ? "caption" : "body1"}
						sx={{
							fontFamily: '"SUIT Variable", sans-serif',
							fontWeight: 800,
							color: theme.palette.text.primary,
							wordBreak: "keep-all",
							lineHeight: 1.5,
							fontSize: isMobile ? "0.75rem" : undefined,
						}}
					>
						{t("discordBanner.description")}
					</Typography>
				</Box>
			</Box>

			<Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0, width: "100%" }}>
				<Button
					variant="contained"
					color="primary"
					onClick={handleJoinClick}
					fullWidth
					sx={{
						fontFamily: '"SUIT Variable", sans-serif',
						fontWeight: 800,
						fontSize: isMobile ? "14px" : "16px",
						height: isMobile ? 36 : 44,
						textTransform: "none",
					}}
				>
					{t("discordBanner.button")}
				</Button>
			</Stack>
		</Stack>
	);
};

export default CommunityJoinCard;


